/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractResponseDto } from '../../models/sales-contract-response-dto';
import { SalesUpdateContractDto } from '../../models/sales-update-contract-dto';

export interface ContractsControllerUpdate$Params {
  tenant: string;
  id: string;
      body: SalesUpdateContractDto
}

export function contractsControllerUpdate(http: HttpClient, rootUrl: string, params: ContractsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractResponseDto>;
    })
  );
}

contractsControllerUpdate.PATH = '/o2-sales/contracts/tenant/{tenant}/{id}';
